<template>
  <p v-if="data.length < 2">
    <img :src="data[0].url" :alt="data[0].alt" onClick="showLightbox(this)" />
  </p>
  <div v-else class="reel">
    <p>
      <img v-for="(item, index) in data" :src="item.url" :alt="item.alt" :key="index" onClick="showLightbox(this)" />
    </p>
  </div>
</template>

<script>
export default {
  name: 'ImageReel',
  computed: {
    data() {
      return this.$slots.default[0].text
        .split('\n')
        .filter(x => x.trim() !== '')
        .map(x => {
          const values = x.split('|');
          if (values.length === 2) return { url: values[1], alt: values[0] };
          return { url: values[0], alt: '' };
        });
    },
  },
};
</script>
